import DesignGuidePage from '../../react/pages/DesignGuidePage';
import { mountReact } from '../../react/utils/mountReact';

mountReact('#product-landing-page', DesignGuidePage);
